import React, { useState, useEffect } from 'react';
import { Outlet, Navigate, Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ACTIONS, URLS, STORAGE } from '../_config';
import { useUserApi } from '../store/api/hooks/userApiHook';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { credentialValue } from '../_common/constant';
import ReCAPTCHA from 'react-google-recaptcha';
import Icon from '../components/icons';
import { useStoreSelector, useAuthStatus } from '../store/selectors/userSelector';
import { useStoreApi } from '../store/api/hooks/storeApiHook';
import Spinner from '../components/iconSvgs/spinner';


const Login: React.FC = () => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [captchaValue, setCaptchaValue] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const userAPI: any = useUserApi();
    const storeAPI: any = useStoreApi();
    const isAuth = useAuthStatus();
    const isStore = useStoreSelector();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = localStorage.getItem(STORAGE);
    const parseData = token ? JSON.parse(token) : null;

    // console.log('store =>', isAuth);
    const { register, formState: { errors }, setValue, handleSubmit, } = useForm<any>();


    const getStores = () => {
        storeAPI.getStore({}, (msg: any, resp: any) => {
            // console.log('response =>', resp, msg);
            if (resp?.data) {
                dispatch({
                    type: ACTIONS.STORE.GET_STORE,
                    payload: resp.data,
                });
                navigate(URLS.STORE.BRANCHES);
            } else {
                navigate(URLS.STORE.CREATE);
            }
        }, (error: any, resp: any) => {
            // console.log('error =>', error, resp);
            if (resp?.detail?.code === 400 || resp?.detail?.code === 404) {
                toast.error(resp?.detail?.message);
                navigate(URLS.STORE.CREATE);
                // navigate(URLS.DASHBOARD);
            }
            // else if (resp?.detail?.code === 401) {
            //     if (!parseData?.access_token) {
            //         dispatch({
            //             type: ACTIONS.USER.LOGOUT,
            //             payload: {},
            //         });
            //         navigate(URLS.LOGIN); 
            //         return; 
            //     }
            //     localStorage.removeItem(STORAGE);
            //     // sessionStorage.clear()
            //     dispatch({
            //         type: ACTIONS.USER.LOGOUT,
            //         payload: {},
            //     });

            //     // Redirect to login page
            //     toast.error('Session expired. Please log in again.');
            //     navigate(URLS.LOGIN);

            // } 
            else {
                toast.error("Something went wrong");
            }
            // navigate(URLS.STORE.CREATE);
            // navigate(URLS.LOGIN);
        })
    }

    const togglePassword = () => {
        setShowPassword(!showPassword); // Toggle the state
    };

    const handleCaptchaChange = (value: any) => {
        // setCaptchaValue(value);
        setCaptchaValue(!!value); // Set validity based on reCAPTCHA response
        setValue('recaptcha', value);
    };

    const login = (data: any) => {
        setOnSubmitLoading(true);
        const formData = new FormData();
        formData.append('username', data.username);
        formData.append('password', data.password);
        const formDataObj: any = {};
        formData.forEach((value, key) => {
            formDataObj[key] = value;
        });

        try {
            setTimeout(() => {
                userAPI.login(formData, (msg: any, resp: any) => {
                    // console.log('response =>', resp, msg);
                    if (resp?.code === 200) {
                        // console.log('response =>', resp, msg);
                        toast.success(resp?.message);
                        getStores();
                    } else {
                        toast.error(resp?.message);
                    }
                }, (err: any) => {
                    console.log('error =>', err);
                    toast.error(err);
                });
                setOnSubmitLoading(false);
            }, 3000);

        } catch (err: any) {
            console.log('error =>', err);
            toast.error(err);
            setOnSubmitLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen">
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            {/* Left Side: Form Section */}
            <div className="flex flex-col justify-center items-center w-full lg:w-4/12 sm:w-4/12 px-6 py-12 lg:px-8 bg-white">
                <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
                    <img className="h-15 w-auto mb-[92px]" src="/assets/images/Frame_2.png" alt="hubwallet logo" />
                    <h2 className="mt-10 text-left text-2xl font-bold tracking-tight text-gray-800">Sign In to HubWallet</h2>
                    <p className="mt-1 text-left text-base tracking-tight text-gray-500">Enter your login details please</p>
                </div>

                <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-2xl">
                    <form onSubmit={handleSubmit(login)}>
                        <div className="mb-4">
                            <div className="mt-2 relative">
                                <input
                                    type="email"
                                    {...register("username", { required: true })}
                                    placeholder="Enter your Email Id"
                                    autoComplete="username"
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.email ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                <Icon name="email" size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" />

                            </div>
                        </div>

                        <div className="mb-4">
                            <div className="mt-2 relative">
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    {...register("password", { required: true })}
                                    autoComplete="current-password" placeholder='Enter your Password'
                                    className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.password ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                                />
                                <Icon name={showPassword ? 'eye' : 'eye-off'} size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" onClick={togglePassword} />
                            </div>

                            <p className='text-right text-gray-400 text-sm py-1'>Forgot Password?</p>
                        </div>

                        <div className="flex flex-shrink-0 mb-3" >

                            <div className="recaptcha-container w-full sm:w-2/3 md:w-1/2">
                                <ReCAPTCHA className={`recaptcha-container ${errors.recaptcha ? 'outline-red-500 outline-2' : 'outline-gray-300'} `}
                                    {...register("recaptcha", { required: "Please complete the reCAPTCHA" })}
                                    sitekey={credentialValue.recaptcha_site_key} // Replace with your site key
                                    onChange={handleCaptchaChange}
                                />
                            </div>
                        </div>
                        {/* {errors.recaptcha && (
                                <span className="text-red-500 text-sm mb-2">Please complete the reCAPTCHA</span>
                            )} */}
                        <div className="mb-3">
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-sm bg-blue-500 p-4 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                Log In
                            </button>
                        </div>
                    </form>

                    <p className="text-center text-sm text-gray-500">
                        New Here?&nbsp;
                        <Link to="/signup" className="font-semibold text-blue-600 hover:text-blue-500">Create an Account</Link>
                    </p>
                </div>
            </div>

            {/* Right Side: Background Image Section */}
            <div className="hidden sm:block lg:w-8/12 sm:w-8/12 bg-cover" style={{ backgroundImage: 'url(/assets/images/2148204009.jpg)', }}>
            </div>
        </div>
    );
};


export default Login;